import { useEffect, useState } from "react";
import axios from "axios";
import { getAnalyticsBaseUrl, getAnalyticsBaseUrlM2C } from "utils/helpers";

export function UseApiCallInternalDashboard({
  url,
  method,
  body,
  skip = false,
  isCvUser = true,
}: any) {
  const [data, setData] = useState<any>();
  const [isLoading, setIsLoading] = useState<boolean>(true);
  const [error, setError] = useState<any>();

  const baseUrl: string = isCvUser
    ? `${getAnalyticsBaseUrl()}`
    : `${getAnalyticsBaseUrlM2C()}`;

  const headers = {
    "Content-Type": "application/json",
    Authorization: isCvUser
      ? "bearer bde14d5ef15ef9f2189e1db876c004907ac857f85976f95d1e3effd350bf60e9"
      : "Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJkYXRhIjp7ImVtYWlsIjoicGFrdGVzdHVzZXJAZ21haWwuY29tIiwiYWN0aXZlIjp0cnVlLCJ0eXBlIjoiQWRtaW4ifSwiaWF0IjoxNzE5MzA5NjUxLCJleHAiOjM0NDEwMzg1MDIsImlzcyI6InVybjpmZW5yaXNQcm92aWRlciIsImp0aSI6InV4TmFZc1NiTEpKb1lCa1RjSUhpeW1BSndUQUI5TlJ2In0.WpDCYer919zSHw_kgGg4sbap6e5rHm_2O0qGVXl6kw4",
  };

  const requestConfig = {
    method,
    url: `${baseUrl}/${url}`,
    headers,
    data: JSON.stringify(body),
    timeout: 100000,
  };

  useEffect(() => {
    if (!skip) {
      getData();
    }
  }, [skip]);

  async function getData() {
    try {
      setIsLoading(true);
      const response = await axios.request(requestConfig);

      setData(response?.data);
    } catch (error) {
      setError(error);
    } finally {
      setIsLoading(false);
    }
  }

  function refetch() {
    getData();
  }

  return { data, isLoading, error, refetch };
}
